import state from "./widget-state";
import mutations from "./widget-mutations";
import actions from "./widget-actions";
const store = {
  namespaced: true,
  state,
  mutations,
  actions
};
export default store;